<template>
  <section class="cards-section">
    <div class="card-grid">
      <div v-for="card in cards" :key="card.id" class="action-card">
        <i v-if="card.icon" class="action-icon icon-glow" :class="card.icon"></i>
        <span class="action-label">{{ card.label }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CardsSection',
  data() {
    return {
      cards: [
        { id: 1, icon: 'iconfont icon-chong', label: 'Deposit' },
        { id: 2, icon: 'iconfont icon-ti', label: 'Withdraw' },
        { id: 3, icon: 'iconfont icon-a-jiedai1', label: 'ICO' },
        { id: 4, icon: 'iconfont icon-a-jiedai1', label: 'Loan' },
      ]
    }
  }
}
</script>

<style scoped>
.cards-section { padding: 0 var(--s-4) var(--s-5); background: var(--bg-page); }
.card-grid { display: grid; grid-template-columns: 1fr 1fr; gap: var(--s-3); }
.action-card {
  display: flex; align-items: center; justify-content: center; gap: var(--s-2);
  padding: var(--s-4) var(--s-3);
  background: linear-gradient(135deg, rgba(92,94,220,0.15), rgba(145,71,255,0.08));
  border: 1px solid rgba(92,94,220,0.2);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--duration-fast);
}
.action-card:hover {
  border-color: rgba(92,94,220,0.4);
  background: linear-gradient(135deg, rgba(92,94,220,0.2), rgba(145,71,255,0.12));
}
.action-icon { font-size: var(--font-size-lg); color: var(--accent); }
.action-label { color: var(--text-primary); font-size: var(--font-size-base); font-weight: 600; }
</style>
